// extracted by mini-css-extract-plugin
module.exports = {"loadMore":"LoadMoreButton_loadMore__18-fG","arrow":"LoadMoreButton_arrow__3YXih"};